import React, { useEffect, useState } from 'react'
import { CircularInput, CircularTrack, CircularThumb } from 'react-circular-input'
import { useDispatch, useSelector } from 'react-redux';
import { add_cycles } from '../app/sleepSlice';
import { Link } from 'react-router-dom'

let deferredPrompt;

async function installPrompt() {
    if (!deferredPrompt) return false
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
        deferredPrompt = null;
    }
}


export default function Main() {
    const dispatch = useDispatch();
    const cycles = useSelector(state => state.sleepCalc.cycles)
    const [minutes, setMinutes] = useState(0);
    const [hours, setHours] = useState(0);
    const [isBeforeNoon, setIsBeforeNoon] = useState(true);
    const [isInstalled, setIsInstalled] = useState(true);
    const [indexSelected, setIndexSelected] = useState(-1);

    const [hourSetter, setHourSetter] = useState(false);
    // 1 - wake up at / 2 - sleep at / 3 - sleep now
    const [sleepType, setSleepType] = useState(0)

    const [hourPercentage, setHourPercentage] = useState(0);
    const [minutePercentage, setMinutePercentage] = useState(0);

    window.addEventListener('beforeinstallprompt', (e) => {
        deferredPrompt = e;
        const app = { name: 'sleeply', installed: false };
        localStorage.setItem('sleeply', JSON.stringify(app))
        setIsInstalled(false);
    });

    window.addEventListener('appinstalled', () => {
        const app = { name: 'sleeply', installed: true };
        localStorage.setItem('sleeply', JSON.stringify(app));
        setIsInstalled(true);
    });

    function handleSleepHour(value) {
        if (value < 1 / 12) value = 1 / 12;
        const currentHour = Math.round(value * 12)
        setHourPercentage(currentHour / 12);
        if (((hours === 11 && currentHour === 12) || (hours === 12 && currentHour === 11)) && isBeforeNoon) {
            setIsBeforeNoon(false)
        }
        if (((hours === 11 && currentHour === 12) || (hours === 12 && currentHour === 11)) && !isBeforeNoon) {
            setIsBeforeNoon(true)
        }
        setHours(currentHour);
    }
    function handleSleepMinutes(value) {
        if (value < 1 / 60) value = 1 / 60;
        const minutes = Math.round(value * 60) === 60 ? 0 : Math.round(value * 60)
        setMinutePercentage(minutes / 60);
        setMinutes(minutes);
    }

    function handleSubmit() {
        if (sleepType === 2) return handleSleep(false)
        if (sleepType === 3) return handleSleep(true)
        dispatch(add_cycles(wakeUpAt({ hours, minutes, isBeforeNoon })))
        setHourSetter(false);
    }

    function handleSleep(now = false) {
        if (!now) {
            setHourSetter(false);
            return dispatch(add_cycles(sleepAt({ hours, minutes, isBeforeNoon })));
        }

        let time = new Date()
        time = convertTime({ hour: time.getHours(), minutes: time.getMinutes() })
        setHours(time.hour)
        setMinutes(time.minutes)
        setIsBeforeNoon(time.state)
        dispatch(add_cycles(sleepAt({ hours: time.hour, minutes: time.minutes, isBeforeNoon: time.state })));
        setHourSetter(false);
    }

    function handleGoBack() {
        setHourSetter(false);
        setSleepType(0);
        dispatch(add_cycles([]))
    }

    useEffect(() => {
        setHourPercentage(hours / 12);
        setMinutePercentage(minutes / 60);
    }, [hours, minutes])

    function handleHintMessage() {
        if (sleepType === 0 || hourSetter) return '...'

        if (sleepType === 3) return (<><span className="badge bg-primary text-black px-3 rounded-pill">sleep now
        </span><p className="flex-fill text-secondary w-100 mt-3">Then wake up at the following hours</p></>)

        if (sleepType === 2) return (<><span className="badge bg-primary text-black px-3 rounded-pill">{`sleep at ${formatTime(hours)}:${formatTime(minutes)} ${isBeforeNoon ? 'AM' : 'PM'}`}</span><p className="flex-fill text-secondary w-100 mt-3">Then wake up at the following hours</p></>)

        if (sleepType === 1) return (<><span className="badge bg-primary text-black px-3 rounded-pill">{`wake up at ${formatTime(hours)}:${formatTime(minutes)} ${isBeforeNoon ? 'AM' : 'PM'}`}</span><p className="flex-fill text-secondary w-100 mt-3">Then go to bed at the following hours</p></>)
    }

    function handleHourSelection(i) {
        if (i < 0 && indexSelected < 0) return setTimeout(() => setIndexSelected(-1), 500)
        setIndexSelected(i);
    }

    return (
        <>
            <header>
                <h1 className={`page-title itemdrop ${(!hourSetter && cycles.length === 0) ? 'drop' : ''}`}><Link to="/">Sleeply</Link></h1>
            </header>
            <main className="section section-input d-flex flex-column justify-content-center h-100">
                <div className={`itemdrop ${(!hourSetter && cycles.length === 0) ? 'drop' : ''}`}>
                    <h2 className="section-title d-flex align-items-center justify-content-center gap-2 flex-wrap">I wish to {handleHintMessage()}</h2>
                    {(hourSetter || cycles.length === 0) && (<div className="d-flex select-inputs align-items-center mt-3">
                        <label className="selection">
                            <input type="radio" name="sleepType" id="wakeUp" checked={(sleepType === 1) ? true : false} onChange={() => { setHourSetter(true); setSleepType(1) }} />
                            <span>Wake up at</span>
                        </label>
                        <label className="selection">
                            <input type="radio" name="sleepType" id="sleepAt" checked={(sleepType === 2) ? true : false} onChange={() => { setHourSetter(true); setSleepType(2) }} />
                            <span>Sleep at</span>
                        </label>
                        <label className="selection">
                            <input type="radio" name="sleepType" id="sleepNow" checked={(sleepType === 3) ? true : false} onChange={({ target: { checked } }) => { if (checked) { handleSleep(true); setSleepType(3) } }} />
                            <span>sleep now </span>
                        </label>
                    </div>)}
                </div>
                {
                    hourSetter && (<div className={`sleepSetter mt-3 ${hourSetter ? 'show' : 'hide'}`}>
                        <div className="position-absolute hours">
                            <CircularInput radius={90} value={hourPercentage} onChange={handleSleepHour}>
                                <CircularTrack strokeWidth={10} stroke={'#3F0876'} />
                                <CircularThumb r={10} stroke={'#fafafa'} fill={'#fafafa'} />
                            </CircularInput>
                        </div>
                        <div className="position-absolute minutes">
                            <CircularInput radius={120} value={minutePercentage} onChange={handleSleepMinutes}>
                                <CircularTrack strokeWidth={2} stroke={'#3F0876'} />
                                <CircularThumb r={10} stroke={'#fafafa'} fill={'#fafafa'} />
                            </CircularInput>
                        </div>
                        <p className="setTime position-absolute">
                            <span>{formatTime(hours)}</span>
                            <span>{formatTime(minutes)}</span>
                            <span>{isBeforeNoon ? 'AM' : 'PM'}</span>
                        </p>
                    </div>)
                }
                {
                    (!hourSetter && cycles.length !== 0) && (
                        <ul className="d-flex flex-wrap my-3 justify-content-center p-0 px-3 px-sm-5 show px-5" style={{ gap: '30px 10px' }}>{cycles.map((val, i) => (
                            <li key={i} className="text-center" tabIndex={0} onBlur={() => handleHourSelection(-1)} onFocus={() => handleHourSelection(i)} style={{ transform: i === indexSelected ? 'scale(1.1)' : null, transition: 'all .2s' }}>
                                <div className="cycleCard d-flex flex-column px-3 pt-4 pb-3">
                                    <span className={`cycleCard_nCycle color-scale-${i + 1}`}>{i + 1}</span>
                                    <span>{formatTime(val.hour)}</span>
                                    <span>{formatTime(val.minutes)}</span>
                                    <span>{val.state ? 'AM' : 'PM'}</span>
                                </div></li>
                        ))}</ul>
                    )
                }
                {(!hourSetter && cycles.length !== 0) && (<p className={`fade lh-base fw-bold ${indexSelected > -1 ? 'fade-in' : null}`}>Sleep for
                    <span className={`badge rounded-pill w-auto px-3 text-dark mx-2 color-scale-${indexSelected + 1}`}>{indexSelected + 1} cycle{indexSelected > 0 ? 's' : ''}</span>or<span className="badge rounded-pill text-black bg-primary w-auto px-3 mx-2 lh-1">{getDuration(indexSelected + 1)}</span>
                </p>)}

                {(!hourSetter && cycles.length !== 0) && (<button type="button" className="btn btn-primary position-relative" style={{ top: indexSelected < 0 ? '-4em' : 0 }} onClick={handleGoBack}>Go back</button>)}
                {hourSetter && (<button type="button" className="btn btn-primary" onClick={handleSubmit}>Sleep</button>)}

            </main >
            <footer className="position-fixed w-100 px-4 d-flex gap-3 justify-content-end align-items-center" style={{ bottom: '1em', left: 0 }}>
                <button type="button" className={`btn btn-cta me-auto ${'serviceWorker' in navigator && !isInstalled ? null : 'd-none'}`} onClick={installPrompt}>Install</button>
                <a href="https://www.buymeacoffee.com/diogochen" className="link-primary" style={{ fontSize: '.7rem' }} target='blank'><img width="16" alt="buy me a coffee" src="img/coffee.svg" /></a>
                <Link to="/privacy-policy" className="link-primary" style={{ fontSize: '.7rem' }}>Privacy Policy</Link>
            </footer>
        </>
    )
}

function convertTime({ hour, minutes }) {
    const state = hour >= 12 ? false : true;
    hour = hour !== 0 && hour !== 12 ? hour % 12 : 12;
    return { hour, minutes, state }

}

function wakeUpAt({ hours, minutes, isBeforeNoon }) {
    hours = isBeforeNoon || (!isBeforeNoon && hours === 12) ? hours : hours + 12;
    hours = hours === 12 && isBeforeNoon ? 0 : hours;
    hours = Number(hours);
    const setHour = new Date(`1970-01-01T${formatTime(hours)}:${formatTime(minutes)}:00`).getTime();

    const cycles = Array(6).fill(0).map((v, i) => {
        let cycleHour = new Date(setHour - (i + 1) * 90 * 60 * 1000 - 15 * 60 * 1000);
        cycleHour = convertTime({ hour: cycleHour.getHours(), minutes: cycleHour.getMinutes() })
        return cycleHour
    });
    return cycles
}

function sleepAt({ hours, minutes, isBeforeNoon }) {
    hours = isBeforeNoon || (!isBeforeNoon && hours === 12) ? hours : hours + 12;
    hours = hours === 12 && isBeforeNoon ? 0 : hours;
    hours = Number(hours);
    const setHour = new Date(`1970-01-01T${formatTime(hours)}:${formatTime(minutes)}:00`).getTime();

    const cycles = Array(6).fill(0).map((v, i) => {
        let cycleHour = new Date(setHour + (i + 1) * 90 * 60 * 1000 + 15 * 60 * 1000);
        cycleHour = convertTime({ hour: cycleHour.getHours(), minutes: cycleHour.getMinutes() })
        return cycleHour
    });
    return cycles
}

function formatTime(value) {
    return value < 10 ? '0' + value : value
}

function getDuration(cycles) {
    const minutes = (cycles * 90);
    return `${formatTime(Math.floor(minutes / 60))} h ${formatTime(minutes % 60)} m`
}